import React, { FC } from 'react';

import { getUserProfileUrl } from '@adsk/acs-sc-web-platform-api';
import { useUser } from '@adsk/alloy-provider';
import Banner, { BANNER_VARIANTS } from '@adsk/alloy-react-banner';
import { Box, Flex } from '@adsk/alloy-react-box';
import Button from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';

import ProjectsHeaderTabs from './ProjectsHeaderTabs';
import ProjectsHeaderTitles from './ProjectsHeaderTitles';
import { useFeatureFlag } from '../../components/LaunchDarklyProvider';
import { MFA_BANNER_SESSION_STORAGE_KEY } from '../../consts';
import { useSessionState } from '../../hooks/useSessionState';
import i18n from '../../utils/i18n';

const ProjectsHeader: FC = () => {
  const { value: isMFASetupRequired } = useFeatureFlag('mfa-setup-required');
  const { user } = useUser();

  const [isMfaBannerVisible, setIsMfaBannerVisible] = useSessionState<boolean>(
    MFA_BANNER_SESSION_STORAGE_KEY,
    true,
  );

  return (
    <>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        justifyItems="center"
        m="16px 48px"
      >
        {isMFASetupRequired && user?.mfaBlocked && isMfaBannerVisible ? (
          <Box style={{ width: '100%' }}>
            <Banner
              data-testid="mfa-banner"
              variant={BANNER_VARIANTS.WARNING}
              message={i18n.t(
                'SOME_OF_YOUR_PROJECTS_REQUIRE_2_STEP_VERIFICATION',
              )}
              style={{ position: 'relative', marginBottom: '32px' }}
              onClose={() => setIsMfaBannerVisible(false)}
            >
              <Button
                data-testid="setup-2-step-verification"
                style={{
                  ...theme.typography.bodySmall,
                  backgroundColor: theme.colors.white,
                }}
                size="small"
                as="a"
                href={`${getUserProfileUrl()}/security`}
              >
                {i18n.t('SETUP_2_STEPS_VERIFICATION')}
              </Button>
            </Banner>
            <ProjectsHeaderTitles />
          </Box>
        ) : (
          <ProjectsHeaderTitles />
        )}
      </Flex>
      <ProjectsHeaderTabs />
    </>
  );
};

export default ProjectsHeader;
